import React, { Component } from 'react'

class AdminDraftedBelts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStart: 0,
      showEnd: 500,
      showText: "Showing drafts 1-500, click to show all"
    }

    this.showAll = this.showAll.bind(this);
  }

  componentDidMount() {
    this.props.adminRequestDraftedBelts();
  }

  showAll() {
    this.setState({
      showEnd: 10000000000000000,
      showText: "Showing all drafted belts (" + this.props.draftedBelts.length + " belts)"
    });
  }

  render() {
    return (
      <div id="admin-submitted-belts">
        <p style={{marginBottom: "10px", color: "blue", textDecoration: "underline"}} onClick={this.showAll}>{this.state.showText}</p>
        <table className="submitted-belt-list">
          <thead>
            <tr>
              <th>Order #</th>
              <th>Name</th>
              <th>Date</th>
              <th>Email</th>
              <th>Notes</th>
              <th>Price</th>
              <th>Size</th>
              <th># Motifs</th>
              <th># Premium</th>
              <th># Custom</th>
              <th>Resend Admin Draft</th>
            </tr>
          </thead>

          <tbody>
            {
              this.props.draftedBelts.map(belt => {
                return (
                  <tr key={belt.id}>
                    <td style={{fontWeight: "bold"}}>{belt.orderNumber}</td>
                    <td style={{fontWeight: "bold"}}>{belt.firstName} {belt.lastName}</td>
                    <td>{new Date(belt.createdAt).toLocaleDateString("en-US")}</td>
                    <td>{belt.email}</td>
                    <td style={{maxWidth: "250px"}}>{belt.notes}</td>
                    <td>${belt.beltPrice}.00</td>
                    <td>{belt.beltSize} in</td>
                    <td>{belt.motifIds.length}</td>
                    <td>{belt.numberPremium}</td>
                    <td>{belt.numberCustom}</td>
                    <td className="resend" onClick={() => this.props.resendAdminDraftEmail(belt.id)}>Resend Admin Draft</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    )
  }
}

export default AdminDraftedBelts;
